import { User } from '../../interfaces/User';
import produce from 'immer';
import { ActionConstants } from './action-constants';
import { AuthActionTypes } from './action-types';
import { BvTokens } from '../../interfaces/Auth';

interface initialStateInterface {
	user_data: User | null;
	tokens: BvTokens | null;
	successAlert: string | null;
}

const initialState = {
	user_data: null,
	tokens: null,
	successAlert: null,
};

export const authReducer = (
	state: initialStateInterface = initialState,
	Action: AuthActionTypes
): initialStateInterface => {
	return produce(state, (auth) => {
		switch (Action.type) {
			case ActionConstants.LOGIN:
				auth.user_data = Action.payload.user;
				auth.tokens = Action.payload.tokens;
				return auth;

			case ActionConstants.LOGOUT:
				auth.user_data = null;
				auth.tokens = null;
				return auth;

			case ActionConstants.OPEN_SUCCESS:
				auth.successAlert = Action.payload;
				return auth;

			case ActionConstants.CLOSE_SUCCESS:
				auth.successAlert = null;
				return auth;

			case ActionConstants.UPDATE_USER_DATA:
				auth.user_data = { ...auth.user_data, ...Action.payload };
				return auth;

			default:
				return auth;
		}
	});
};
